import { PRIO } from '../../../constants';
import { DriveItem, ListItemFieldColumnName } from '../../../models/Drive';
import { MessageAttachment } from '../../../models/Message';
import { DriveItemId, DriveItemListItemId } from '../../../models/Types';
import { PreviewListItem } from '../reducers/previewModal';

export declare type PreviewContext =
  | 'documents'
  | 'messages'
  | 'globalDocumentsSearch'
  | '';
export interface OpenCurrentPreviewModalAction {
  type: string;
  visibility: boolean;
  driveItemId: string;
  groupId: string;
  driveItem: DriveItem;
  messageAttachment: MessageAttachment[];
  messageId: string;
  projectId: string;
  isLoading: boolean;
  selectedDriveItems: DriveItem[];
  context: PreviewContext;
}

export const OPEN_CURRENT_PREVIEW_MODAL = PRIO + 'OPEN_CURRENT_PREVIEW_MODAL';

export const setCurrentPreviewModalVisibility = (
  visibility: boolean,
  driveItemId: string,
  groupId: string,
  driveItem: DriveItem,
  itemList: Array<PreviewListItem>,
  pageNumber: number,
  messageId: string,
  projectId: string,
  isLoading: boolean,
  selectedDriveItems: DriveItem[],
  context: PreviewContext
) => ({
  type: OPEN_CURRENT_PREVIEW_MODAL,
  visibility,
  driveItemId,
  groupId,
  driveItem,
  itemList,
  pageNumber,
  messageId,
  projectId,
  isLoading,
  selectedDriveItems,
  context,
});

export const UPDATE_DRIVE_ITEM_META_DATA_PREVIEW_MODAL =
  PRIO + 'UPDATE_DRIVE_ITEM_META_DATA_PREVIEW_MODAL';

export const updateDriveItemMetaDataPreviewModal = (
  update: Array<{
    listItemId?: DriveItemListItemId;
    driveItemId: DriveItemId;
    columnName: ListItemFieldColumnName;
    values: string[];
  }>
) => ({
  type: UPDATE_DRIVE_ITEM_META_DATA_PREVIEW_MODAL,
  update,
});
